import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { errorToast } from "../../../utils/toasts";

export const useDeletePrograms = () => {
  const { t } = useTranslation(["programs"]);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ids: number[]) =>
      await Promise.all(ids.map(async (id) => await apiClient.deleteProgram(undefined, { params: { id } }))),
    // Settled, not success: some deletes may have gone through before one failed.
    onSettled: async () => await queryClient.invalidateQueries({ queryKey: ["programs"] }),
    onError: (error) => {
      errorToast({ message: t(($) => $.programs.list["Failed to delete one or more programs"]), error });
    },
  });
};
